import { Theme } from "@deere/fuel-react";
import { SxProps } from "@mui/material";

export const headingSx = (theme: Theme): SxProps<Theme> => ({
  fontWeight: theme.tokens.FuelFontWeightSemibold,
  fontSize: theme.tokens.FuelFontSizeMd,
  color: theme.tokens.FuelColorTextPrimary,
  paddingBottom: theme.tokens.FuelSpacing1,
});

export const valueSx = (theme: Theme): SxProps<Theme> => ({
  fontWeight: theme.tokens.FuelFontWeightRegular,
  fontSize: theme.tokens.FuelFontSizeMd,
  color: theme.tokens.FuelColorTextHeading,
});
